import type { ReactElement } from "react";
import { memo } from "react";

import { FIND_APPS_BUTTON_SIZE } from "../../constants";

import { StyledFilterItemCardExpandButton, StyledFilterItemCollapseIconWrapper } from "./styles";

interface IProps {
    isExpanded?: boolean;
    onClick?(): void;
}

const FilterItemExpandButton = ({ isExpanded = false, onClick }: IProps): ReactElement => {
    return (
        <StyledFilterItemCollapseIconWrapper isExpanded={isExpanded}>
            <StyledFilterItemCardExpandButton
                type="flat"
                iconSize="sm"
                height={FIND_APPS_BUTTON_SIZE}
                width={FIND_APPS_BUTTON_SIZE}
                iconName="chev-down"
                dataAutomation="filters-item.expand-toggle-button"
                onClick={onClick}
            />
        </StyledFilterItemCollapseIconWrapper>
    );
};

export default memo(FilterItemExpandButton);
